import { render, staticRenderFns } from "./Sfzl.vue?vue&type=template&id=7abcc59d&scoped=true"
var script = {}
import style0 from "./Sfzl.vue?vue&type=style&index=0&id=7abcc59d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abcc59d",
  null
  
)

export default component.exports